import React, { useEffect, useState } from "react";
import IconPencil from "./IconPencil";
import IconUndo from "./IconUndo";
import CharacterInfoSection from "./CharacterInfoSection";
import CharacterCharacteristics from "./CharacterCharacteristics";
import CharacterPoints from "./CharacterPoints";
import CharacterSkills from "./CharacterSkills";
import CharacterWeapons from "./CharacterWeapons";
import CharacterEquipments from "./CharacterEquipments";
import CharacterCash from "./CharacterCash";
import CharacterBackground from "./CharacterBackground";

function CharacterDetailTemplate_Desktop({
  character,
  handleDiceRoll,
  handleDiceWeaponRoll,
  handleSaveCharacter,
  editMode,
  handleSwitchEditMode,
}) {
  const [section, setSection] = useState("info");

  // Inizializza la sezione dall'hash dell'URL
  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    const validSections = [
      "info",
      "characteristics",
      "points",
      "skills",
      "weapons",
      "equipments",
      "background",
      "cash",
    ];
    if (hash && validSections.includes(hash)) {
      setSection(hash);
    }
  }, []);

  const handleChangeSection = (newSection) => {
    setSection(newSection);
    // Aggiorna l'hash nell'URL
    window.history.replaceState(null, "", `#${newSection}`);
  };

  if (!character) return null;

  return (
    <div className="character-sheetpage desktop">
      {editMode ? (
        <h2>
          {character.characterInfo.name}{" "}
          <IconUndo onClick={() => handleSwitchEditMode()} />
        </h2>
      ) : (
        <h2>
          {character.characterInfo.name}{" "}
          <IconPencil onClick={() => handleSwitchEditMode()} />
        </h2>
      )}
      <div className="character-sheetpage_wrapper">
        <div className="character-sheetpage_sections">
          <ul>
            <li
              className={section === "info" ? "active" : "inactive"}
              onClick={() => handleChangeSection("info")}
            >
              Informazioni
            </li>
            <li
              className={section === "characteristics" ? "active" : "inactive"}
              onClick={() => handleChangeSection("characteristics")}
            >
              Caratteristiche
            </li>
            <li
              className={section === "points" ? "active" : "inactive"}
              onClick={() => handleChangeSection("points")}
            >
              Punti
            </li>
            <li
              className={section === "skills" ? "active" : "inactive"}
              onClick={() => handleChangeSection("skills")}
            >
              Abilità
            </li>
            <li
              className={section === "weapons" ? "active" : "inactive"}
              onClick={() => handleChangeSection("weapons")}
            >
              Armi
            </li>
            <li
              className={section === "equipments" ? "active" : "inactive"}
              onClick={() => handleChangeSection("equipments")}
            >
              Equipaggiamento
            </li>
            <li
              className={section === "background" ? "active" : "inactive"}
              onClick={() => handleChangeSection("background")}
            >
              Background
            </li>
            <li
              className={section === "cash" ? "active" : "inactive"}
              onClick={() => handleChangeSection("cash")}
            >
              Soldi
            </li>
          </ul>
        </div>
        <div className="character-sheetpage_sectioncontent">
          {section === "info" && (
            <CharacterInfoSection
              character={character}
              editMode={editMode}
              handleSaveCharacter={handleSaveCharacter}
            />
          )}
          {section === "characteristics" && (
            <CharacterCharacteristics
              editMode={editMode}
              character={character}
              handleDiceRoll={handleDiceRoll}
              handleSaveCharacter={handleSaveCharacter}
            />
          )}
          {section === "points" && (
            <CharacterPoints
              editMode={editMode}
              character={character}
              handleDiceRoll={handleDiceRoll}
              handleSaveCharacter={handleSaveCharacter}
            />
          )}
          {section === "skills" && (
            <CharacterSkills
              editMode={editMode}
              character={character}
              handleDiceRoll={handleDiceRoll}
              handleSaveCharacter={handleSaveCharacter}
            />
          )}
          {section === "weapons" && (
            <CharacterWeapons
              editMode={editMode}
              character={character}
              handleDiceRoll={handleDiceWeaponRoll}
              handleSaveCharacter={handleSaveCharacter}
            />
          )}
          {section === "equipments" && (
            <CharacterEquipments
              editMode={editMode}
              character={character}
              handleSaveCharacter={handleSaveCharacter}
            />
          )}
          {section === "background" && (
            <CharacterBackground
              editMode={editMode}
              character={character}
              handleSaveCharacter={handleSaveCharacter}
            />
          )}
          {section === "cash" && (
            <CharacterCash
              editMode={editMode}
              character={character}
              handleSaveCharacter={handleSaveCharacter}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default CharacterDetailTemplate_Desktop;
